import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { API_BASE_URL } from '../config';
import './ServicesPageHeaderEditor.css';

export default function ServicesPageHeaderEditor() {
  const { authenticatedFetch } = useAuth();
  const [form, setForm] = useState({ servicesPageTitle: '', servicesPageLead: '' });
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    (async () => {
      const res = await fetch(`${API_BASE_URL}/api/homepage`);
      if (!res.ok) return;
      const data = await res.json();
      setForm({
        servicesPageTitle: data.servicesPageTitle || '',
        servicesPageLead: data.servicesPageLead || '',
      });
    })();
  }, []);

  function update(field, value) {
    setForm((f) => ({ ...f, [field]: value }));
  }

  async function onSave(e) {
    e.preventDefault();
    setSaving(true);
    setStatus(null);
    try {
      const res = await authenticatedFetch(`${API_BASE_URL}/api/homepage`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error('Save failed');
      setStatus({ kind: 'ok', text: 'Saved.' });
    } catch (e) {
      setStatus({ kind: 'err', text: 'Save failed. Try again.' });
    } finally {
      setSaving(false);
    }
  }

  return (
    <form className="services-page-header-editor" onSubmit={onSave}>
      <h3>Page header</h3>
      <p className="services-page-header-hint">Heading and lead paragraph at the top of the public Services page.</p>
      <label>
        Page title
        <input
          value={form.servicesPageTitle}
          onChange={(e) => update('servicesPageTitle', e.target.value)}
          placeholder="Services"
        />
      </label>
      <label>
        Page lead
        <textarea
          rows={3}
          value={form.servicesPageLead}
          onChange={(e) => update('servicesPageLead', e.target.value)}
          placeholder="Therapeutic massage and bodywork — tailored to what your body needs today."
        />
      </label>
      <div className="services-page-header-actions">
        <button type="submit" disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
        {status && <span className={`status ${status.kind}`}>{status.text}</span>}
      </div>
    </form>
  );
}
